<script>
	import { onMount, setContext } from 'svelte'
	import FrameElementExplorer from '@Views/FrameElementExplorer.svelte'
	import Preview from '@Views/Preview.svelte'
	import Toolbar from './Toolbar.svelte'
	import Guide from '@Views/Guide/Guide.svelte'
	import Holebar from '@Views/Holebar.svelte'
	import OptionsPanel from '@Views/OptionsPanel.svelte'
	import Messages from '@Views/Messages.svelte'
	import Tooltip from '@Views/Tooltip.svelte'
	import LoadingIndicator from '@Components/LoadingIndicator.svelte'
	import { guiDimensionsStore } from '@Stores/stores.js'
	export let isAdmin
	export let isDev
	export let canvas
	export let controller
	export let renderer
	export let config
	export let guideController
	export let colorSchemeManager
	export let editorState
	$: unauthorized = controller.unauthorized
	$: fatalError = false
	$: uploadingContent = false
	$: uploadMessage = ''
	$: loadCompleted = false
	$: downForMaintainance = import.meta.env.VITE_DOWN_FOR_MAINTAINANCE === 'true';
	setContext('editor', {
		isAdmin: isAdmin,
		isDev: isDev,
		getEditorCanvas: () => canvas,
		getConfig: () => config,
		getController: () => controller,
		getEditorState: () => editorState,
		getRenderer: () => renderer,
		getGuide: () => guideController,
		getColorSchemeManager: () => colorSchemeManager
	})
	let codes = controller.getCodes()
	controller.on('statusUpdated', function (s) {
		fatalError = s.code === codes.error
	})
	controller.on('fetchCompleted', function () {
		loadCompleted = true
	})
	controller.on('awaitingReload', function (message) {
		uploadingContent = true
		uploadMessage = message
	})
	controller.on('authorizationStatus', (s) => {
		unauthorized = s
	})
</script>

<div class="gui" bind:clientWidth={$guiDimensionsStore.w} bind:clientHeight={$guiDimensionsStore.h}>
	{#if downForMaintainance}
	<div style="position:absolute; z-index: 2;" class="flex justify-center items-center w-full h-full bg-black/80 duration-300 ease-in-out">
		<div style="width: 280px;" class="box rounded-lg p-4">
			<div class="flex flex-col">

					<span class="text-lg">Down for maintainance</span>
					<p class="text-sm pb-5">Sorry for the inconvenience. The service will soon be available again!</p>
					<button
					class="btn btn-sm btn-solid-blue"
					on:click={() => {
						window.parent.postMessage(
							{
								action: 'closeMap'
							},
							config.golfOfficeFrontendURL
						)
					}}>Back to golfoffice</button
				>
			</div>
		</div>
	</div>
	{:else if uploadingContent}
		<div style="position:absolute; z-index: 2;" class="flex justify-center items-center w-full h-full bg-black/80 duration-300 ease-in-out">
			<div style="width: 300px;" class="box rounded-lg p-4">
				<div class="flex flex-row justify-items-start gap-4">
					<div class="h-10 pt-[7px]">
						<LoadingIndicator color="white" />
					</div>
					<div>
						{#if uploadMessage}
							<span class="text-lg">{uploadMessage}</span>
							<p class=text-sm>Please reload your browser</p>
						{:else}
							<span class="text-lg">Uploading content...</span>
							<p class="text-sm">Please wait while the editor is uploading the content. Once completed the browser will reload</p>
						{/if}
					</div>
				</div>
			</div>
		</div>}
	{:else if unauthorized}
		<div style="position:absolute; z-index: 2;" class="flex justify-center items-center w-full h-full">
			<div style="width: 300px;">
				<h1 class="text-lg">Unauthorized</h1>
				<p class="text-sm">You are not authorized to access this page. Please return to golfoffice to continue</p>
				<br />
				<button
					class="btn btn-sm btn-solid-blue"
					on:click={() => {
						window.parent.postMessage(
							{
								action: 'closeMap'
							},
							config.golfOfficeFrontendURL
						)
					}}>Back to golfoffice</button
				>
			</div>
		</div>
	{:else if fatalError}
		<div style="position:absolute; z-index: 2;" class="flex justify-center items-center w-full h-full">
			<div style="width: 300px;">
				<h1 class="text-lg">Fatal error</h1>
				<p class="text-sm">An error occurred while loading the editor. Try realoading the page. If the error perists please contact customer support!</p>
				<br />
				<button
					class="btn btn-sm btn-solid-blue"
					on:click={() => {
						window.location.reload()
					}}>Reload</button
				>
				<button
					class="btn btn-sm btn-solid-white"
					on:click={() => {
						window.parent.postMessage(
							{
								action: 'closeMap'
							},
							config.golfOfficeFrontendURL
						)
					}}>Back to golfoffice</button
				>
			</div>
		</div>
	{:else}
		{#if loadCompleted}
			<Preview />
			<Toolbar />
			<OptionsPanel />
			<Holebar />
			<Tooltip />
		{:else}
			<div style="position:absolute; z-index: 2;" class="flex justify-center items-center w-full h-full bg-black/80 duration-300 ease-in-out">
				<div style="width: 300px;" class="box rounded-lg p-4">
					<div class="flex flex-row justify-items-start gap-4">
						<div class="h-10 pt-[7px]">
							<LoadingIndicator color="white" />
						</div>
						<div>
							<span class="text-lg">Loading editor...</span>
							<p class="text-sm">Please wait while the editor is fetching all the resourses</p>
						</div>
					</div>
				</div>
			</div>
		{/if}
		<Messages />
		<Guide controller={guideController} />
	{/if}
</div>

<style lang="postcss">
	.gui {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		display: flex;
	}
</style>
